import { Button } from './Button';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { cn } from '@/utils/cn';

interface ErrorRetryProps {
  message?: string;
  onRetry?: () => void;
  className?: string;
}

export function ErrorRetry({
  message = 'Algo deu errado',
  onRetry,
  className,
}: ErrorRetryProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-12 px-4 text-center',
        className
      )}
    >
      <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center mb-4">
        <AlertCircle className="w-6 h-6 text-destructive" />
      </div>
      <p className="text-muted-foreground mb-4">{message}</p>
      {onRetry && (
        <Button onClick={onRetry} variant="secondary" size="sm">
          <RefreshCw className="w-4 h-4 mr-2" />
          Tentar novamente
        </Button>
      )}
    </div>
  );
}


